import axios, { AxiosRequestConfig } from 'axios'

import { IRecommend } from '@/types/recommend'

export const getBrandSkus = async (
  name: string,
  code = '',
  categoryId = -1,
  jicsfClassificationCds: number[] = [],
): Promise<IRecommend[]> => {
  const config: AxiosRequestConfig = {
    params: {
      name,
      code,
      categoryId,
      jicsfClassificationCds: jicsfClassificationCds.join(','),
    },
  }
  try {
    const response = await axios.get<IRecommend[]>('brand-skus', config)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.brandSkus.getBrandSkus')
  }
}

export const suggestBrandSkus = async (
  name: string,
  code = '',
  categoryId = -1,
): Promise<IRecommend[]> => {
  const config: AxiosRequestConfig = {
    params: {
      name,
      code,
      categoryId,
    },
  }
  try {
    const response = await axios.get<IRecommend[]>('brand-skus/suggest', config)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.brandSkus.suggestBrandSkus')
  }
}
